import React, { Component } from 'react';

import {
  SCREEN_ID_SUNSETUP_DRIVER_ORDERS,
} from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrSunSetupDriverOrders from 'client/components/SrSunSetupDriverOrders/SrSunSetupDriverOrders';

@withTransitionHook
@withScreenId(SCREEN_ID_SUNSETUP_DRIVER_ORDERS)
@withScrollToTop
class SunSetupDriverOrdersPage extends Component {
  render() {
    const {
      match,
    } = this.props;

    return (
      <SrPartnerPageV2
        navbarTitle='SunSetup'
      >
        <SrSunSetupDriverOrders
          driverId={parseInt(match.params.driverId, 10)}
        />
      </SrPartnerPageV2>
    );
  }
}

SunSetupDriverOrdersPage.displayName = 'SunSetupDriverOrdersPage';

export default SunSetupDriverOrdersPage;
